import axios from 'axios';

export const getDropdownUsers = async () => {
    return await axios.get(`${window._HOST}admin/users/dropdown`, {withCredentials: true});
}

export const getAllDataTableUsers = async (searchText = null, offset = 0, limit = 0, sortingCol = 0, sortingMode = 'DESC') => {
    if(searchText) {
        return await axios.get(`${window._HOST}admin/users/dataTable?search-text=${searchText}&offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`, {withCredentials: true})
    } else {
        return await axios.get(`${window._HOST}admin/users/dataTable?offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`, {withCredentials: true})
    }
}

export const insertNewUser = async (formData) => {
    return await axios.post(`${window._HOST}admin/users`,formData, {withCredentials: true, headers: {"Content-Type": "multipart/form-data"}})
}

export const updateUser = async (formData, id_user) => {
    return await axios.post(`${window._HOST}admin/users/${id_user}`, formData, {withCredentials: true, headers: {"Content-Type" : "multipart/form-data"}})
}

export const deleteUser = async (id_user) => {
    return await axios.delete(`${window._HOST}admin/users/${id_user}`, {withCredentials: true})
}

export const changeStatusUser = async (id_user) => {
    return await axios.get(`${window._HOST}admin/users/changeStatusUser/${id_user}`, {withCredentials: true})
}